import { authPagePath } from "../auth/resume";
import { useCallbackUrl } from "../store/usePartnerStore";
import { useRouteWithToken } from "./useRouteWithToken";

const isValidHttpUrl = (url: string): boolean =>
  url.startsWith("http://") || url.startsWith("https://");

/**
 * Exit CTA for error / session screens: leave to the partner callback URL when
 * configured; otherwise auth with resume=transactions. Anonymous home is forbidden.
 */
export const useExitToPartnerOrLanding = () => {
  const callbackUrl = useCallbackUrl();
  const { redirectTo } = useRouteWithToken();
  const partnerUrl =
    callbackUrl && isValidHttpUrl(callbackUrl) ? callbackUrl : null;

  const exitToPartnerOrLanding = () => {
    if (partnerUrl) {
      window.location.href = partnerUrl;
      return;
    }
    redirectTo(authPagePath({ kind: "transactions" }));
  };

  const exitToPartnerOnly = () => {
    if (partnerUrl) {
      window.location.href = partnerUrl;
    }
  };

  return {
    exitToPartnerOrLanding,
    exitToPartnerOnly,
    canExitToPartner: !!partnerUrl,
  };
};
